export default __webpack_public_path__ + "static/media/coming-soon-Logo.3d234fed.png";